import { render } from "./admin-statistics.vue?vue&type=template&id=f2af22c4"
import script from "./admin-statistics.vue?vue&type=script&lang=js"
export * from "./admin-statistics.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__